/**
 * @module useAuditTotalLogs
 * Singleton module-level ref shared between AuditLogs.vue (writer) and
 * AppBar.vue (reader) so the app bar can display a chip with the total
 * audit log count without a direct parent-child relationship.
 */

import { ref } from "vue";

// Module-level singleton — shared across all consumers
const totalLogs = ref(0);

export function useAuditTotalLogs() {
  return { totalLogs };
}
